import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomerData } from "@cinch-labs/customer-data-segment";
import styles from "./winter-sale.module.css";
export function WinterSaleBanner(param) {
    var sendDigitalDataEvent = param.sendDigitalDataEvent;
    var trackEvent = useCustomerData().trackEvent;
    var handleOnClick = function() {
        var data = {
            event: {
                name: "click",
                category: "winter flash sale",
                action: "shop cars on offer",
                label: "hero"
            }
        };
        // TECHDEBT - currently this only fires *some* of the time,
        // there is a ticket SCD-284 to fix it and make it more accurate
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Winter sale promo banner - cars on offer",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.saveTag,
                children: "SAVE"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: styles.text,
                children: [
                    "Save up to ",
                    /*#__PURE__*/ _jsx("b", {
                        children: "\xa31000"
                    }),
                    " on",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/find-vehicle?tags=cars-on-offer",
                        onClick: handleOnClick,
                        children: "selected cars"
                    }),
                    ". Discount varies by car.",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/policies/winter-sale",
                        children: "T&Cs apply."
                    })
                ]
            })
        ]
    });
}
export default WinterSaleBanner;
